import { i18n } from '@/plugins/i18n';
import { CURRENCIES } from '@/constansts/currency';

const priceDisplay = (amount, currency, locale = i18n.locale) => {
  if (amount || amount === 0) {
    const options = {
      style: 'currency',
      currency,
    };
    
    // Fix for currencies with 0 decimal digits in Spanish locale
    // Ensure thousand separators are shown even for amounts < 10,000
    const currencyInfo = CURRENCIES[currency];
    if (locale === 'es' && currencyInfo?.decimal_digits === 0) {
      options.useGrouping = true;
    }
    
    return new Intl.NumberFormat(locale, options).format(amount);
  }
  return '';
};

const roundNumber = (number, decimalPlaces = 2) => {
  if (number || number === 0) {
    return +(`${Math.round(`${number}e+${decimalPlaces}`)}e-${decimalPlaces}`);
  }
  return number;
};

const percentageDisplay = (amount) => {
  if (amount || amount === 0) {
    const roundAmount = roundNumber(amount);
    return `${roundAmount}%`;
  }
  return '';
};
const getCurrencySymbol = (currency, locale = i18n.locale) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  });
  const parts = formatter.formatToParts(1000);
  return parts.find((part) => part.type === 'currency').value;
};

export default {
  priceDisplay,
  roundNumber,
  percentageDisplay,
  getCurrencySymbol,
};
